import template from './loansDetail.html';
import controller from './loansDetail.controller';
import './loansDetail.scss';

let loansDetailComponent = {
  restrict: 'E',
  bindings: {
    serviceClosed: '<',
  },
  template,
  controller,
};

export default loansDetailComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetail.component.js